import React from 'react'
import { IconButton } from 'react-toolbox/lib/button'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'recompose'
import notifyHoc from 'containers/App/Notification/Notify'
import T from 'i18n-react'

import styles from './styles.scss'

const InfoButton = notifyHoc(IconButton)

const InfoDialogButton = (props) => {
  return (
    <InfoButton
      message={T.translate('pages.project.view.notification.viewLifecycleInfoDialog')}
      onClick={props.onClick}
      icon='info'
    />
  )
}

export default compose(
  CSSModules(styles)
)(InfoDialogButton)
